class FiskalyReportController extends AbstractController
	@register()
	@inject 'integrations',
		'registers'
		'shops'
		'IntegrationRepository'
		'RenderRepository'
		'ToastService'
		'translate'
		'$timeout'

	POLL_INTERVAL: 3000
	FINISHED_MODE: 'FINISHED'
	FAILED_STATE: 'FAILED'
	FISKALY_PT_ID: 'fiskaly_pt'
	FISKALY_AT_ID: 'fiskaly_at'
	FISKALY_ES_ID: 'fiskaly_es'
	FISKALY_DE_ID: 'fiskaly_de'

	initialize: ->
		@datePickerConfig =
			maxDate: moment()
			singleDatePicker: true

		@isGenerating = false

		@fiskalyIntegrations = _.filter @integrations, (integration) ->
			return integration.id? && integration.id.indexOf('fiskaly_') == 0

		@selectedIntegrationId = @fiskalyIntegrations[0]?.id

		lastMonth = moment().subtract(1, 'months')

		@filter =
			from: lastMonth.startOf('month').unix()
			to: lastMonth.endOf('month').unix()

		@selectedRegisterId = null
		@selectedShopId = null

	hasMultipleIntegrations: ->
		return @fiskalyIntegrations.length > 1

	isFiskalyAt: ->
		return @selectedIntegrationId == @FISKALY_AT_ID

	isFiskalyEs: ->
		return @selectedIntegrationId == @FISKALY_ES_ID

	isFiskalyDe: ->
		return @selectedIntegrationId == @FISKALY_DE_ID

	usesRegisterSelector: ->
		return @isFiskalyAt() || @isFiskalyDe()

	download: ->
		return if !@selectedIntegrationId? || @isGenerating
		return if @usesRegisterSelector() && !@selectedRegisterId?
		return if @isFiskalyEs() && !@selectedShopId?

		@isGenerating = true

		@createExportRequest()
			.then (response) => @pollExport response.data
			.catch =>
				@isGenerating = false

	createExportRequest: ->
		if @isFiskalyAt()
			register = _.find(@registers, {id: @selectedRegisterId})
			cashRegisterId = _.find(register?.attributes, 'fiskaly_client_id')?.fiskaly_client_id

			return @IntegrationRepository.createFiskalyAtExport(
				@selectedIntegrationId,
				cashRegisterId,
				@filter.from,
				@filter.to
			)

		if @isFiskalyEs()
			return @IntegrationRepository.createFiskalyEsExport(
				@selectedIntegrationId,
				@selectedShopId,
				@filter.from,
				@filter.to
			)

		if @isFiskalyDe()
			register = _.find(@registers, {id: @selectedRegisterId})
			clientId = _.find(register?.attributes, 'fiskaly_client_id')?.fiskaly_client_id

			return @IntegrationRepository.createFiskalyDeExport(
				@selectedIntegrationId,
				clientId,
				@filter.from,
				@filter.to
			)

		return @IntegrationRepository.createExport(@selectedIntegrationId, @filter.from, @filter.to)

	pollExport: (file) ->
		if file.state == @FAILED_STATE
			@stopGenerating()
			@ToastService.add(
				@translate('general.report.fiskaly.generation_failed'),
				@translate('general.report.type.fiskaly'),
				@translate('general.error'),
				'error'
			)

			return

		if file.mode == @FINISHED_MODE
			@stopGenerating()
			@RenderRepository.downloadFromUrl @IntegrationRepository.getExportDownloadUrl(@selectedIntegrationId, file.id)

			return

		@$timeout(
			=>
				@refreshExport file.id
			,
			@POLL_INTERVAL
		)

	refreshExport: (id) ->
		@IntegrationRepository
			.getExportStatus @selectedIntegrationId, id
			.then (response) =>
				@pollExport response.data
			.catch =>
				@stopGenerating()

	stopGenerating: ->
		@isGenerating = false

	isDownloadDisabled: ->
		if @selectedIntegrationId == null || @isGenerating
			return true

		if @usesRegisterSelector() && @selectedRegisterId == null
			return true

		if @isFiskalyEs() && @selectedShopId == null
			return true

		return false
